
import PreEntryApi from '../../assets/js/preentry'
import Validate from '../../assets/js/pre_validate'
import { i18nHelper } from '@it-common/lbp_common'
import OnboardHeader from '../OnboardHeader'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'


export default {
components: {
XButton,
Group,
Cell,
PopupRadio,
XInput,
Loading,
Datetime,
XTextarea,
Confirm,
OnboardHeader
},
data () {
return {
workList: [],
id: '',
isZH: localStorage.getItem('offer_zh') === 'zh',
deleteRowsConfirm: false,
deleteCurIndex: '',
showLoading: true,
no_working: 1,
code: '',
hiring_type: '',
mobileFlag: false,
workTypeItems: [
{ key: 1, value: this.$tsg('实习工作') },
{ key: 2, value: this.$tsg('全职正式工作') }
],
start_date: ''
}
},
created () {
this.id = this.$route.query.id

this.mobileFlag = this.isMobile()


var localStorage = window.localStorage
this.code = localStorage.getItem('pre_code')
i18nHelper.loadLanguagePack(4159)
i18nHelper.setFixedLocale(localStorage.getItem('offer_zh'))
this.$forceUpdate()

if (!this.code || !this.id) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}

PreEntryApi.checkLogin(
{ id: this.id, code: this.code },
(data, meta) => {
if (data && data.isSubmit === true) {
this.$router.push({ name: 'onboard.preview', query: { id: this.id } })

}
},
err => {
this.showLoading = false
if (err === -2) {
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
},
err => {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
return false
}
)


PreEntryApi.getStaffDetail(
{ id: this.id, code: this.code },

(data, meta) => {
if (data) {
this.data = data
this.hiring_type = data.hiring_type
this.showLoading = false
this.start_date = data.start_date
}
},

err => {
if (err === 2) {
this.showLoading = false
this.$router.push({ name: 'onboard.code', query: { id: this.id } })
}
this.showLoading = false
return false
}
)


PreEntryApi.getStatusValue({ id: this.id, code: this.code }, (data, meta) => {
if (data) {
this.no_working = data.no_working
}
})

PreEntryApi.getExperience(
{ id: this.id, getField: 'work_experience', code: this.code },
(data, meta) => {
if (data) {
this.workList = data
this.workList.forEach(
function (item, key) {
if (this.isZH) {
if (!Validate.isMobile(item.contact_number)) {
this.workList[key].contact_number_state = false
} else {
this.workList[key].contact_number_state = true
}
} else {
this.workList[key].contact_number_state = true
}
}.bind(this)
)
} else {
this.addWork()
}
this.showLoading = false
},
(code, message) => {
if (code === -1) {
this.addWork()
}
this.showLoading = false
},
err => {
this.showLoading = false
},
err => {
this.showLoading = false
}
)
},
methods: {
clear (type, key, val) {
if (val) {
this[type][key][val] = ''
} else {
this[type] = ''
}
},
isMobile () {
if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
return true
}
return false
},
deleteRows (key) {
this.deleteRowsConfirm = true
this.deleteCurIndex = key
},
sendDel () {
this.workList.splice(this.deleteCurIndex, 1)

thindMaterial(3)
},
contactNumberState (key) {
if (this.isZH) {
if (!Validate.isMobile(this.workList[key].contact_number)) {
this.workList[key].contact_number_state = false
} else {
this.workList[key].contact_number_state = true
}
} else {
this.workList[key].contact_number_state = true
}
},
changeWorkStatus () {
this.no_working = this.no_working === 1 ? 2 : 1
if (this.no_working === 2) {
this.workList = []
PreEntryApi.saveExperience(
{
id: this.id,
code: this.code,
work_experience: this.workList,
saveField: 'work_experience'
},
(data, meta) => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}
},
(code, message) => {
this.$message.error(this.$tsg('资料信息更新失败。'))
}
)
if (this.workList.length === 0) {
this.addWork()
}
} else {
if (this.workList.length === 0) {
this.addWork()
}
}

PreEntryApi.updateStatusValue(
{
id: this.id,
field: 'no_working',
no_working: this.no_working,
code: this.code
},
(data, meta) => {},
err => {
this.$message.error(this.$tsg('状态字段更新失败。'))
}
)
},
removeWork () {
this.workList.pop()
},
addWork () {
if (this.workList.length === 4) {
this.$message.error(this.$tsg('工作经历只需填写最近4个。'))
return false
}

/*
var newEntryDate = '',newQuitDate = '';
if(this.workList.length > 0) {
var quitDate = this.workList[this.workList.length - 1].quit_date;
if(quitDate) {
newEntryDate = quitDate;
newQuitDate  = quitDate;
}
}
*/

this.workList.push({
work_type: '',
entry_date: '',
quit_date: '',
work_unit: '',
company: '',
depart: '',
post: '',
reterence: '',
contact_number: '',
quit_cause: ''
})
},

getIsZh (data) {
var localStorage = window.localStorage
if (data) {
localStorage.setItem('offer_zh', 'zh')

} else {
localStorage.setItem('offer_zh', 'en')

}
this.isZH = data
},
sendMaterial (returnFlag) {
if (!this.id) {
this.$message.error(this.$tsg('非法操作。'))
return false
}


var listLength = this.workList.length,
workList = []
for (var i = 0; i < listLength; i++) {
if (
this.workList[i]['work_type'] ||
this.workList[i]['entry_date'] ||
this.workList[i]['work_unit'] ||
this.workList[i]['depart'] ||
this.workList[i]['post'] ||
this.workList[i]['reterence'] ||
this.workList[i]['contact_number'] ||
this.workList[i]['quit_cause']
) {
if (this.no_working !== 2 && !this.workList[i]['contact_number_state']) {
this.$message.error(this.$tsg('手机号格式错误'))
return false
}
console.log(this.workList[i]['entry_date'] > this.workList[i]['quit_cause'], this.workList[i]['entry_date'], this.workList[i]['quit_date'], this.start_date)
if (this.workList[i]['entry_date'] >= this.workList[i]['quit_date']) {
this.$message.error(this.$tsg('系统识别您所填写的工作经历存在入职日期晚于等于离职日期的情况，请您确认信息后重新填写。'))
return false
}
if (this.workList[i]['quit_date'] >= this.start_date) {
this.$message.error(this.$tsg('系统识别您所填写的工作经历尚未结束，请确认后重新填写，如上一份劳动关系尚未结束，请联系您的招聘修改入职日期。'))
return false
}
workList.push(this.workList[i])
}
}

if (this.no_working === 2) {
this.workList = []
}

PreEntryApi.saveExperience(
{
id: this.id,
code: this.code,
work_experience: workList,
saveField: 'work_experience'
},
(data, meta) => {
if (data !== '') {
this.$message.error(this.$tsg('资料信息更新失败。'))
return false
}

if (returnFlag === 2) {
this.$router.push({ name: 'onboard.train', query: { id: this.id } })
} else if (returnFlag === 1) {
this.$router.push({ name: 'onboard.list', query: { id: this.id } })
} else if (returnFlag === 3) {

}
},
(code, message) => {
this.$message.error(this.$tsg('资料信息更新失败。'))
}
)
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/work.vue